function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M57.8184 89.2886L100.445 126.046C101.569 127.042 104.458 127.93 108.841 125.396C113.224 122.863 113.896 119.916 113.594 118.446L103.017 63.1617L57.8184 89.2886Z",
  fill: "#C4FFF3",
  stroke: "#141414",
  strokeWidth: 0.949219,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M70.707 100.402C79.2934 97.068 85.779 91.2202 90.1983 83.6756C93.1024 78.7175 95.074 73.1032 96.2189 67.0913L84.8662 73.6536C84.125 75.5617 83.2631 77.3608 82.2807 79.0379C78.1411 86.1052 71.7363 91.2504 62.5023 93.3273L70.707 100.402Z",
  fill: "#F8FFD3"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M85.2831 112.972L77.688 106.422C84.1791 103.815 88.935 99.3937 92.2438 93.7448C96.5261 86.434 98.52 76.8037 98.2002 65.9461L103.017 63.1615L106.377 80.7227C105.268 87.1407 103.238 93.1299 100.161 98.3825C96.5715 104.511 91.6183 109.52 85.2831 112.972Z",
  fill: "#F8FFD3"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M99.6003 125.317L92.3908 119.101C96.6715 116.486 100 112.917 102.502 108.647C105.538 103.464 107.424 97.1154 108.15 89.9905L112.031 110.274C111.53 111.302 110.993 112.306 110.42 113.284C107.636 118.037 104.032 122.116 99.6003 125.317Z",
  fill: "#F8FFD3"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M70.707 100.402C79.2934 97.068 85.779 91.2202 90.1983 83.6756C93.1024 78.7175 95.074 73.1032 96.2189 67.0913L84.8662 73.6536C84.125 75.5617 83.2631 77.3608 82.2807 79.0379C78.1411 86.1052 71.7363 91.2504 62.5023 93.3273L70.707 100.402Z",
  stroke: "#141414",
  strokeWidth: 0.949219,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M85.2831 112.972L77.688 106.422C84.1791 103.815 88.935 99.3937 92.2438 93.7448C96.5261 86.434 98.52 76.8037 98.2002 65.9461L103.017 63.1615L106.377 80.7227C105.268 87.1407 103.238 93.1299 100.161 98.3825C96.5715 104.511 91.6183 109.52 85.2831 112.972Z",
  stroke: "#141414",
  strokeWidth: 0.949219,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M99.6003 125.317L92.3908 119.101C96.6715 116.486 100 112.917 102.502 108.647C105.538 103.464 107.424 97.1154 108.15 89.9905L112.031 110.274C111.53 111.302 110.993 112.306 110.42 113.284C107.636 118.037 104.032 122.116 99.6003 125.317Z",
  stroke: "#141414",
  strokeWidth: 0.949219,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref9 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 79.9429,
  cy: 75.4033,
  rx: 26.2617,
  ry: 9.33398,
  transform: "rotate(-30.0296 79.9429 75.4033)",
  fill: "white",
  stroke: "#141414",
  strokeWidth: 0.949219,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref10 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 80.4782,
  cy: 76.4921,
  rx: 24.8835,
  ry: 8.00771,
  transform: "rotate(-30.0296 80.4782 76.4921)",
  fill: "#141414"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M129.58 63.9883C126.416 61.204 120.773 60.9297 118.348 61.1407L124.676 54.1796C133.535 53.8 138.703 62.7753 140.18 67.3105L135.275 71.1074C134.695 69.8945 132.744 66.7727 129.58 63.9883Z",
  fill: "#F8FFD3"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M85.125 52.5977L83.543 46.4277L90.0293 45.3203L90.9785 50.0664L85.125 52.5977Z",
  fill: "#FAC6D4"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M75 59.2422V52.5977L68.3555 54.4961L75 59.2422Z",
  fill: "#C4FFF3"
});

var _ref14 = /*#__PURE__*/React.createElement("circle", {
  cx: 62.3438,
  cy: 37.4102,
  r: 3.16406,
  fill: "#F8FFD3"
});

var _ref15 = /*#__PURE__*/React.createElement("circle", {
  cx: 48.2637,
  cy: 49.2754,
  r: 2.05664,
  fill: "#C4FFF3"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M41.1445 34.4043L37.0312 32.1895C38.8031 29.0254 41.8828 25.7031 43.2012 24.4375L48.2637 27.7598L41.1445 34.4043Z",
  stroke: "#141414",
  strokeWidth: 0.949219,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M22.6348 60.9086C22.793 62.7015 24.0902 66.6355 28.0137 68.0277C30.8978 69.0511 32.9065 67.4483 35.1016 65.6968C36.6391 64.47 38.2682 63.1701 40.3535 62.6488C45.416 61.3832 48.7383 64.7054 50.1621 66.7621L46.0488 70.2425C45.2578 69.0297 42.8848 66.8886 39.7207 68.0277C38.2893 68.543 37.1273 69.4727 35.9723 70.3969C33.9357 72.0264 31.9205 73.6386 28.4883 72.932C22.0978 71.6163 19.4707 62.9652 19.4707 60.9086C18.3105 60.7504 15.3574 59.8644 12.8262 57.5863C9.66211 54.7386 5.07422 51.891 0.644531 54.7386L1.11914 48.7268C2.85938 48.0939 7.13086 47.6193 10.2949 50.7834C14.25 54.7386 16.3066 56.1626 19.7871 56.6372C19.9453 54.8443 20.9262 50.5622 23.584 47.7778C26.9062 44.2974 31.4941 44.6138 33.2344 48.0943C34.9746 51.5747 31.9688 59.6429 22.6348 60.9086ZM22.793 56.9535C24.375 56.9535 27.9274 56.0043 28.9629 53.4731C30.3867 49.9926 28.9629 48.727 27.5391 48.5688C26.1152 48.4106 23.1094 50.4672 22.793 56.9535Z",
  fill: "#FAC6D4"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M74.209 42.7892L80.0625 38.5177C79.0078 36.6192 76.9301 31.0505 77.0567 23.963C77.2149 15.1036 82.2774 13.9962 84.0176 15.1036C83.1738 17.6876 81.9926 24.5325 84.0176 31.2404C86.5488 39.6251 93.5098 41.2072 96.832 39.3087C100.945 36.9583 100.787 28.8673 96.9903 21.4318C94.2506 16.0666 90.293 12.7834 89.5547 12.4142C90.6621 10.5158 92.9086 7.38333 96.832 6.87708C101.736 6.24427 105.375 13.2051 106.641 23.963L111.387 18.7423C110.385 14.4709 106.83 5.45328 100.629 3.55484C92.877 1.1818 87.9727 8.61734 86.8652 10.5158C84.9141 9.67203 79.9676 8.87047 75.791 12.4142C70.5703 16.8439 68.3555 30.6074 74.209 42.7892ZM87.0234 16.2111C86.4433 18.7951 85.6312 24.849 87.0234 28.3927C88.7636 32.8224 91.9277 34.088 93.5097 33.1388C95.0917 32.1896 95.0918 22.381 87.0234 16.2111Z",
  fill: "#C4FFF3",
  stroke: "#141414",
  strokeWidth: 0.949219
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M44.4668 95.1543L36.3984 96.1035C35.3859 99.5207 35.1328 105.227 35.1328 107.652L44.4668 109.076C41.809 102.115 43.3594 96.8945 44.4668 95.1543Z",
  stroke: "#141414",
  strokeWidth: 0.949219,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref20 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 62.5746,
  cy: 102.864,
  rx: 2.68945,
  ry: 3.32227,
  transform: "rotate(21.2639 62.5746 102.864)",
  fill: "#C4FFF3",
  stroke: "#141414",
  strokeWidth: 0.949219
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "M125.625 78.3848C127.154 79.2285 131.099 80.916 134.643 80.916",
  stroke: "#141414",
  strokeWidth: 0.949219,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: "M109.33 47.0605H115.342",
  stroke: "#141414",
  strokeWidth: 0.949219,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  d: "M46.6816 78.543L37.3477 86.1367",
  stroke: "#141414",
  strokeWidth: 0.949219,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  d: "M47.3145 117.145V123.314",
  stroke: "#141414",
  strokeWidth: 0.949219,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  d: "M9.66211 34.8789L18.9961 36.6191",
  stroke: "#141414",
  strokeWidth: 0.949219,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  d: "M63.7676 1.33984L62.1855 8.61719",
  stroke: "#141414",
  strokeWidth: 0.949219,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref27 = /*#__PURE__*/React.createElement("path", {
  d: "M47.9473 34.2461C52.2715 35.1426 61.173 39.6566 62.1855 50.541C63.4512 64.1465 46.998 77.1191 50.0039 96.7363C52.4086 112.43 67.7754 113.189 77.2148 111.607",
  stroke: "#141414",
  strokeWidth: 0.949219,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref28 = /*#__PURE__*/React.createElement("path", {
  d: "M112.811 101.482C116.08 101.271 122.493 102.21 121.987 107.652C120.246 117.144 92.719 111.765 84.967 122.048C77.2151 132.332 96.9904 141.191 109.488 129.009",
  stroke: "white",
  strokeWidth: 1.58203,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref29 = /*#__PURE__*/React.createElement("path", {
  d: "M112.811 100.216C116.08 100.005 122.493 100.944 121.987 106.386C120.246 115.878 92.719 110.5 84.967 120.783C77.2151 131.066 96.9904 139.925 109.488 127.744",
  stroke: "#141414",
  strokeWidth: 0.949219,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgSurveyend(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 141,
    height: 139,
    viewBox: "0 0 141 139",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSurveyend);
export default __webpack_public_path__ + "static/media/surveyend.48b67917.svg";
export { ForwardRef as ReactComponent };